<template>
  <div class="equipment-unit" @click="unitClick" :class="active ? 'active' : ''">
    <div class="unit-img">
      <img :src="imgUrl" width="100%" height="100%"/>
    </div>
    <div class="unit-content">
      <p class="top">备注名称：{{deviceName}}</p>
      <p class="idcenter">设备ID：{{deviceidEx}}</p>
      <p class="bottom">{{(active ? '默认设备' : '未选中')}}</p>
    </div>
    <button class="btn" @click.stop="btnClick">删除设备</button>
  </div>
</template>
<script>
import Common from '../../../assets/js/common.js'
export default {
  name: 'EquipmentUnit',
  props: {
    equipNUmber: String,
    deviceid: Number,
    active: Boolean,
    index: Number,
    deviceidEx: String,
    deviceName: String
    // position: String
  },
  data () {
    return {
      imgUrl: Common.staticHref() + 'img/equipment.jpg'
    }
  },
  methods: {
    btnClick () {
      this.$emit('btnClick', {deviceid: this.deviceid, index: this.index})
    },
    unitClick () {
      this.$emit('unitClick', this.deviceid, this.deviceidEx)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl';
  .equipment-unit
    width 343px;
    height 93px;
    background #ffffff;
    padding 22px 17px;
    box-sizing border-box;
    border-radius 5px;
    rowCenter();
    position relative
    .unit-img
      width 47px;
      height 60px;
    .unit-content
      padding-left 18px;
      flex 1;
      .top
        height 20px;
        line-height 22px;
        font-size 14px;
        color #333333;
        min-width 0;
        ellipsis();
      .idcenter
        height 20px;
        line-height 22px;
        font-size 14px;
        color #333333;
        min-width 0;
        ellipsis();
      .bottom
        height 20px;
        line-height 22px;
        font-size 12px;
        color #666666;
        min-width 0;
        ellipsis();
    .btn
      font-size 14px
      padding 5px
      background transparent
      width 100
      margin-left 20px
      color #334f5f
      position absolute
      // z-index 2
      right 14px
      // top 20px
      // height 20px
  .active
    border 1px solid #394E5D
</style>



// WEBPACK FOOTER //
// src/pages/EquipmentList/components/EquipmentUnit.vue